import React from 'react';

import {
  FormControl,
  FormHelperText,
  ToggleButton,
  ToggleButtonGroup,
  ToggleButtonGroupProps,
  ToggleButtonProps,
} from '@mui/material';
import { FieldInputProps, FieldMetaState } from 'react-final-form';

import { getFieldError, hasFieldError } from 'src/utils/finalForm';

export interface ToggleButtonGroupFieldProps extends ToggleButtonGroupProps {
  input: FieldInputProps<any>;
  meta: FieldMetaState<any>;
  ToggleButtonProps?: Omit<ToggleButtonProps, 'value'>;
  options: Array<{
    value: any;
    component: React.ReactElement;
  }>;
  withAbilityToChooseNothing?: boolean;
}

export const ToggleButtonGroupField: React.FC<ToggleButtonGroupFieldProps> = ({
  input,
  meta,
  options,
  ToggleButtonProps,
  withAbilityToChooseNothing = true,
  ...rest
}) => {
  const { value, onBlur, onFocus, onChange } = input;
  const error = hasFieldError(meta);
  const helperText = getFieldError(meta);

  const onChangeValue: ToggleButtonGroupProps['onChange'] = (_, value) => {
    if (withAbilityToChooseNothing || value !== null) {
      onChange(value);
    }
  };

  return (
    <FormControl error={error}>
      <ToggleButtonGroup
        value={value}
        onChange={onChangeValue}
        onBlur={onBlur}
        onFocus={onFocus}
        {...rest}
      >
        {options.map(({ component, value }) => (
          <ToggleButton key={value} value={value} {...ToggleButtonProps}>
            {component}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
      {Boolean(helperText) && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};
